import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom';
import FolderIcon from '@mui/icons-material/Folder';
import TabIcon from '@mui/icons-material/Tab';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import Groups3Icon from '@mui/icons-material/Groups3';
import GoogleIcon from '@mui/icons-material/Google';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import LensBlurIcon from '@mui/icons-material/LensBlur';
import PolylineIcon from '@mui/icons-material/Polyline';
import HubIcon from '@mui/icons-material/Hub';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import LanIcon from '@mui/icons-material/Lan';
import bing from '../media/bing.png'
import spider from '../media/spider2.png'
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import SpeedIcon from '@mui/icons-material/Speed';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import SubjectIcon from '@mui/icons-material/Subject';
import AddLinkIcon from '@mui/icons-material/AddLink';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import PolicyIcon from '@mui/icons-material/Policy';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import Diversity2Icon from '@mui/icons-material/Diversity2'
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity'
import CategoryIcon from '@mui/icons-material/Category'
import InsightsIcon from '@mui/icons-material/Insights';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import TimelineIcon from '@mui/icons-material/Timeline';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SupportIcon from '@mui/icons-material/Support';
import ConstructionIcon from '@mui/icons-material/Construction';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useDispatch } from 'react-redux';
import { changePath } from '../Redux/BackgroundEffectSlice';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SummarizeIcon from '@mui/icons-material/Summarize';


function Sidebar({ fr, sPathSetter, sPath, toolsStates }) {
    const [path, setPath] = useState('')
    const [prevPath, setPrevPath] = useState('')
    const [opt, setOpt] = useState('')

    const [width, setWidth] = useState(window.innerWidth);

    const linkStyles = {
        textDecoration: 'none'
    }

    const dispatch = useDispatch()


    useEffect(()=> {
        const uPath = window.location.pathname.replace('/', '')

        switch (uPath) {
            case '':
            setPrevPath(path)
            setPath('')
            setOpt('')
            dispatch(changePath(''))
            break;


            case 'projects':
            setPrevPath(path)
            setPath('ms')
            setOpt('progs')
            dispatch(changePath('ms'))
            break;

            
            case 'keyword-research':
            setPrevPath(path)
            setPath('res')
            setOpt('kr')
            dispatch(changePath('res'))
            break;

            case 'competition-research':
            setPrevPath(path)
            setPath('res')
            setOpt('cr')
            dispatch(changePath('res'))
            break;
            
            case 'trend-research':
            setPrevPath(path)
            setPath('res')
            setOpt('tr')
            dispatch(changePath('res'))
            break;

            case 'google-serp':
            setPrevPath(path)
            setPath('se')
            setOpt('gs')
            dispatch(changePath('se'))
            break;

            case 'bing-serp':
            setPrevPath(path)
            setPath('se')
            setOpt('bs')
            dispatch(changePath('se'))
            break;

            case 'top-search-queries':
            setPrevPath(path)
            setPath('se')
            setOpt('tsq')
            dispatch(changePath('se'))
            break;

            case 'indexed-pages':
            setPrevPath(path)
            setPath('se')
            setOpt('ip')
            dispatch(changePath('se'))
            break;

            case 'sitemaps':
            setPrevPath(path)
            setPath('se')
            setOpt('sm')
            dispatch(changePath('se'))
            break;
            
            case 'page-seo-health-test':
            setPrevPath(path)
            setPath('tst')
            setOpt('psht')
            dispatch(changePath('tst'))
            break;

            case 'crawlability-test':
            setPrevPath(path)
            setPath('tst')
            setOpt('ct')
            dispatch(changePath('tst'))
            break;

            case 'mobile-support-test':
            setPrevPath(path)
            setPath('tst')
            setOpt('mst')
            dispatch(changePath('tst'))
            break;

            case 'headers-test':
            setPrevPath(path)
            setPath('tst')
            setOpt('ht')
            dispatch(changePath('tst'))
            break;

            case 'speed-test':
            setPrevPath(path)
            setPath('tst')
            setOpt('st')
            dispatch(changePath('tst'))
            break;

            case 'content-ideation':
            setPrevPath(path)
            setPath('cntnt')
            setOpt('ci')
            dispatch(changePath('cntnt'))
            break;

            case 'link-analysis':
            setPrevPath(path)
            setPath('cntnt')
            setOpt('la')
            dispatch(changePath('cntnt'))
            break;

            case 'keyword-density':
            setPrevPath(path)
            setPath('cntnt')
            setOpt('kd')
            dispatch(changePath('cntnt'))
            break;
            
            case 'extract-meta-tags':
            setPrevPath(path)
            setPath('cntnt')
            setOpt('emt')
            dispatch(changePath('cntnt'))
            break;

            case 'high-quality-backlinks':
            setPrevPath(path)
            setPath('bl')
            setOpt('hqb')
            dispatch(changePath('bl'))
            break;

            case 'new-backlinks':
            setPrevPath(path)
            setPath('bl')
            setOpt('nbl')
            dispatch(changePath('bl'))
            break;

            case 'low-quality-backlinks':
            setPrevPath(path)
            setPath('bl')
            setOpt('lqb')
            dispatch(changePath('bl'))
            break;

            case 'top-referrers':
            setPrevPath(path)
            setPath('bl')
            setOpt('tr')
            dispatch(changePath('bl'))
            break;

            case 'page-authority':
            setPrevPath(path)
            setPath('bl')
            setOpt('pa')
            dispatch(changePath('bl'))
            break;
            
            case 'domain-authority':
            setPrevPath(path)
            setPath('bl')
            setOpt('da')
            dispatch(changePath('bl'))
            break;

            case 'pricing':
            setPrevPath(path)
            setPath('')
            setOpt('')
            dispatch(changePath(''))
            break;

            case 'account-settings':
            setPrevPath(path)
            setPath('account-settings')
            setOpt('')
            dispatch(changePath(''))
            break;

            case 'management':
            setPrevPath(path)
            setPath('management')
            setOpt('')
            dispatch(changePath(''))
            break;
        }


        if(path !== prevPath) fr()

    }, [window.location.href, path])



    useEffect(() => {
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
 
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);



    const checkToolState = (tool) => {
        const selectedTool = toolsStates?.tools.find(t=> t.tool === tool)

        return selectedTool?.state
    }


    const toolStateMsg = (tool) => {
        const selectedTool = toolsStates?.tools.find(t=> t.tool === tool)

        return selectedTool?.message
    }




  return (
    <>
    {(width > 768) && <>
    {path !== 'account-settings' && path !== 'management' && <SidebarContainer>
        <p style={{marginTop: '60px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='ms' && 'lightpink'}}>My Space</p>
        <Link to='/projects' style={linkStyles} onClick={()=> {setPath('ms'); setOpt('progs')}}><SidebarOption state={true}><FolderIcon /><span style={opt === 'progs'? {color: 'lightpink'}: {}}> Projects</span></SidebarOption></Link>
        <CSOption><Diversity2Icon /> Collaboration<CSBox>Comming soon!</CSBox></CSOption>
        

        <p style={{marginTop: '20px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='res' && 'var(--res-color)'}}>Research</p>
        <Link to={checkToolState('keyword-research') && '/keyword-research'} style={linkStyles} onClick={()=> {if(!checkToolState('keyword-research')) {return}; setPath('res'); setOpt('kr')}}><SidebarOption state={checkToolState('keyword-research')}><FindInPageIcon /> <span style={opt === 'kr'? {color: 'var(--res-color)'}: {}}>Keyword Research</span> {!checkToolState('keyword-research') && <><ConstructionIcon style={{color: 'orange', opacity: '0.7', position: 'relative'}}/></>}</SidebarOption></Link>
        <Link to={checkToolState('competition-research') && '/competition-research'} style={linkStyles} onClick={()=> {if(!checkToolState('competition-research')){return};setPath('res'); setOpt('cr')}}><SidebarOption state={checkToolState('competition-research')}><Groups3Icon /> <span style={opt === 'cr'? {color: 'var(--res-color)'}: {}}>Competition Research</span>{!checkToolState('competition-research') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('trend-research') && '/trend-research'} style={linkStyles} onClick={()=> {if(!checkToolState('trend-research')){return};setPath('res'); setOpt('tr')}}><SidebarOption state={checkToolState('trend-research')}><TrendingUpIcon /> <span style={(opt === 'tr' && path === 'res')? {color: 'var(--res-color)'}: {}}>Trend Research</span>{!checkToolState('trend-research') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <CSOption><ReduceCapacityIcon /> <span>Demographic Research</span> <CSBox>Comming soon!</CSBox></CSOption>
        <CSOption><CategoryIcon /> <span>Product Research</span> <CSBox>Comming soon!</CSBox></CSOption>

        <p style={{marginTop: '20px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='se' && 'var(--se-color)'}}>Search Engines</p>
        <Link to={checkToolState('google-search') && '/google-serp'} style={linkStyles} onClick={()=> {if(!checkToolState('google-search')){return};setPath('se'); setOpt('gs')}}><SidebarOption state={checkToolState('google-search')}><GoogleIcon /> <span style={opt === 'gs'? {color: 'var(--se-color)'}: {}}>Google SERP</span>{!checkToolState('google-search') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('bing-search') && '/bing-serp'} style={linkStyles} onClick={()=> {if(!checkToolState('bing-search')){return};setPath('se'); setOpt('bs')}}><SidebarOption state={checkToolState('bing-search')}><img src={bing} width={20} style={{marginRight: '8px'}} /> <span style={opt === 'bs'? {color: 'var(--se-color)'}: {}}> Bing SERP</span>{!checkToolState('bing-search') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('top-search-queries') && '/top-search-queries'} style={linkStyles} onClick={()=> {if(!checkToolState('top-search-queries')){return};setPath('se'); setOpt('tsq')}}><SidebarOption state={checkToolState('top-search-queries')}><DeviceHubIcon /><span style={opt === 'tsq'? {color: 'var(--se-color)'}: {}}>Top Search Queries</span>{!checkToolState('top-search-queries') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>} </SidebarOption></Link>
        <Link to={checkToolState('indexed-pages') && '/indexed-pages'} style={linkStyles} onClick={()=> {if(!checkToolState('indexed-pages')){return};setPath('se'); setOpt('ip')}}><SidebarOption state={checkToolState('indexed-pages')}><PolylineIcon /> <span style={opt === 'ip'? {color: 'var(--se-color)'}: {}}>Indexed Pages</span>{!checkToolState('indexed-pages') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        {/* <SidebarOption><MiscellaneousServicesIcon /> Robots.txt</SidebarOption> */}
        <Link to={checkToolState('sitemaps') && '/sitemaps'} style={linkStyles} onClick={()=> {if(!checkToolState('sitemaps')){return};setPath('se'); setOpt('sm')}}><SidebarOption state={checkToolState('sitemaps')}><LanIcon /> <span style={opt === 'sm'? {color: 'var(--se-color)'}: {}}>Sitemaps</span>{!checkToolState('sitemaps') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>

        <p style={{marginTop: '20px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='tst' && 'var(--tst-color)'}}>Tests</p>
        <Link to={checkToolState('page-seo-health-test') && '/page-seo-health-test'} style={linkStyles} onClick={()=> {if(!checkToolState('page-seo-health-test')){return};setPath('tst'); setOpt('psht')}}><SidebarOption state={checkToolState('page-seo-health-test')}><SummarizeIcon /> <span style={opt === 'psht'? {color: 'var(--tst-color)'}: {}}>Page SEO Health Test</span>{!checkToolState('page-seo-health-test') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('crawlability-test') && '/crawlability-test'} style={linkStyles} onClick={()=> {if(!checkToolState('crawlability-test')){return};setPath('tst'); setOpt('ct')}}><SidebarOption state={checkToolState('crawlability-test')}><img src={spider} width={20} style={{marginRight: '8px'}} /> <span style={opt === 'ct'? {color: 'var(--tst-color)'}: {}}>Crawlability Test</span>{!checkToolState('crawlability-test') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('mobile-support-test') && '/mobile-support-test'} style={linkStyles} onClick={()=> {if(!checkToolState('mobile-support-test')){return};setPath('tst'); setOpt('mst')}}><SidebarOption state={checkToolState('mobile-support-test')}><AppSettingsAltIcon /> <span style={opt === 'mst'? {color: 'var(--tst-color)'}: {}}>Mobile Support Test</span>{!checkToolState('mobile-support-test') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('headers-test') && '/headers-test'} style={linkStyles} onClick={()=> {if(!checkToolState('headers-test')){return};setPath('tst'); setOpt('ht')}}><SidebarOption state={checkToolState('headers-test')}><WysiwygIcon /> <span style={opt === 'ht'? {color: 'var(--tst-color)'}: {}}>Headers Test</span>{!checkToolState('headers-test') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('speed-test') && '/speed-test'} style={linkStyles} onClick={()=> {if(!checkToolState('speed-test')){return};setPath('tst'); setOpt('st')}}><SidebarOption state={checkToolState('speed-test')}><SpeedIcon /> <span style={opt === 'st'? {color: 'var(--tst-color)'}: {}}>Speed Test</span>{!checkToolState('speed-test') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>

        <p style={{marginTop: '20px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='cntnt' && 'var(--cntnt-color)'}}>Content</p>
        <Link to={checkToolState('content-ideation') && '/content-ideation'} style={linkStyles} onClick={()=> {if(!checkToolState('content-ideation')){return};setPath('cntnt'); setOpt('ci')}}><SidebarOption state={checkToolState('content-ideation')}><AutoAwesomeIcon /> <span style={opt === 'ci'? {color: 'var(--cntnt-color)'}: {}}>Content Ideation</span>{!checkToolState('content-ideation') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        {/* <Link to={checkToolState('link-analysis') && '/link-analysis'} style={linkStyles} onClick={()=> {if(!checkToolState('link-analysis')){return};setPath('cntnt'); setOpt('la')}}><SidebarOption state={checkToolState('link-analysis')}><InsertLinkIcon /> <span style={opt === 'la'? {color: 'var(--cntnt-color)'}: {}}>Link Analysis</span>{!checkToolState('link-analysis') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link> */}
        <Link to={checkToolState('keyword-density') && '/keyword-density'} style={linkStyles} onClick={()=> {if(!checkToolState('keyword-density')){return};setPath('cntnt'); setOpt('kd')}}><SidebarOption state={checkToolState('keyword-density')}><LensBlurIcon /><span style={opt === 'kd'? {color: 'var(--cntnt-color)'}: {}}>Keyword Density</span>{!checkToolState('keyword-density') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('extract-meta-tags') && '/extract-meta-tags'} style={linkStyles} onClick={()=> {if(!checkToolState('extract-meta-tags')){return};setPath('cntnt'); setOpt('emt')}}><SidebarOption state={checkToolState('extract-meta-tags')}><SubjectIcon /> <span style={opt === 'emt'? {color: 'var(--cntnt-color)'}: {}}>Extract Meta Tags</span>{!checkToolState('extract-meta-tags') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>

        <p style={{marginTop: '20px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small', color: path=='bl' && 'var(--bl-color)'}}>Backlinks</p>
        <Link to={checkToolState('high-quality-backlinks') && '/high-quality-backlinks'} style={linkStyles} onClick={()=> {if(!checkToolState('high-quality-backlinks')){return};setPath('bl'); setOpt('hqb')}}><SidebarOption state={checkToolState('high-quality-backlinks')}><StarHalfIcon /> <span style={opt === 'hqb'? {color: 'var(--bl-color)'}: {}}>High Quality Backlinks</span>{!checkToolState('high-quality-backlinks') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('new-backlinks') && '/new-backlinks'} style={linkStyles} onClick={()=> {if(!checkToolState('new-backlinks')){return};setPath('bl'); setOpt('nbl')}}><SidebarOption state={checkToolState('new-backlinks')}><AddLinkIcon /><span style={opt === 'nbl'? {color: 'var(--bl-color)'}: {}}>New Backlinks</span>{!checkToolState('new-backlinks') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('low-quality-backlinks') && '/low-quality-backlinks'} style={linkStyles} onClick={()=> {if(!checkToolState('low-quality-backlinks')){return};setPath('bl'); setOpt('lqb')}}><SidebarOption state={checkToolState('low-quality-backlinks')}><LinkOffIcon /> <span style={opt === 'lqb'? {color: 'var(--bl-color)'}: {}}>Low Quality Backlinks</span>{!checkToolState('low-quality-backlinks') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('top-referrers') && '/top-referrers'} style={linkStyles} onClick={()=> {if(!checkToolState('top-referrers')){return};setPath('bl'); setOpt('tr')}}><SidebarOption state={checkToolState('top-referrers')}><ZoomInMapIcon /> <span style={(opt === 'tr' && path == 'bl')? {color: 'var(--bl-color)'}: {}}>Top Referrers</span>{!checkToolState('top-referrers') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('page-authority') && '/page-authority'} style={linkStyles} onClick={()=> {if(!checkToolState('page-authority')){return};setPath('bl'); setOpt('pa')}}><SidebarOption state={checkToolState('page-authority')}><PlagiarismIcon /> <span style={opt === 'pa'? {color: 'var(--bl-color)'}: {}}>Page Authority</span>{!checkToolState('page-authority') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>
        <Link to={checkToolState('domain-authority') && '/domain-authority'} style={linkStyles} onClick={()=> {if(!checkToolState('domain-authority')){return};setPath('bl'); setOpt('da')}}><SidebarOption state={checkToolState('domain-authority')}><PolicyIcon /> <span style={opt === 'da'? {color: 'var(--bl-color)'}: {}}>Domain Authority</span>{!checkToolState('domain-authority') && <ConstructionIcon style={{color: 'orange', opacity: '0.7'}}/>}</SidebarOption></Link>

        <div style={{marginTop: '100px'}}></div>
    </SidebarContainer>}
    {path === 'account-settings' && <SidebarContainer>
        <p style={{marginTop: '60px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small'}}>Account Settings</p>
        <SidebarOption onClick={()=> sPathSetter('acc-stats')} style={{color: sPath === 'acc-stats'? 'dodgerblue': ''}} state={true}><InsightsIcon /> Account Stats</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('acc-settings')} style={{color: sPath === 'acc-settings'? 'dodgerblue': ''}} state={true}><SettingsApplicationsIcon /> Account Settings</SidebarOption>

        <div style={{marginTop: '100px'}}></div>
    </SidebarContainer>}
    
    {path === 'management' && <SidebarContainer>
        <p style={{marginTop: '60px', marginBottom: '10px', padding: '10px 10px 0px 5px', fontSize: 'small'}}>Management</p>
        <SidebarOption onClick={()=> sPathSetter('stats')} style={{color: sPath === 'stats'? 'dodgerblue': ''}} state={true}><TimelineIcon />Stats</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('operations')} style={{color: sPath === 'operations'? 'dodgerblue': ''}} state={true}><SettingsIcon />Operations</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('feedbacks')} style={{color: sPath === 'feedbacks'? 'dodgerblue': ''}} state={true}><ChatBubbleIcon />Feedbacks</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('support')} style={{color: sPath === 'support'? 'dodgerblue': ''}} state={true}><SupportIcon />Support</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('cfeedbacks')} style={{color: sPath === 'cfeedbacks'? 'dodgerblue': ''}} state={true}><AnnouncementIcon />cancellation Feedbacks</SidebarOption>
        <SidebarOption onClick={()=> sPathSetter('announcement')} style={{color: sPath === 'announcement'? 'dodgerblue': ''}} state={true}><FormatAlignLeftIcon />Announcement</SidebarOption>
        <div style={{marginTop: '100px'}}></div>
    </SidebarContainer>}
    </>}
    
    
    {width < 768 && <>
    
    <MContainer>
    <ToolsDrag>
        <span>Tools <ChevronRightIcon /></span>
    </ToolsDrag>


    </MContainer>

    </>}
    </>
  )
}

export default Sidebar



const SidebarContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* flex: 0.18; */
    width: 15%;
    background-color: var(--ml-color);
    color: rgba(255, 255, 255, 0.7);
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;



    &::-webkit-scrollbar {
        width: 8px;
    }


    &::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.7);
    }


    &::-webkit-scrollbar-thumb:hover {
        background-color: lightgray;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track:hover {
        background-color: transparent;
    }

    > .cs_option {
        position: relative !important;
        cursor: not-allowed !important;
    }
`


    const SidebarOption = styled.div`
        padding: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.15);
        color: ${props=> props.state? 'white': 'rgba(255, 255, 255, 0.25)'};
        cursor: ${props=> props.state? 'pointer': 'not-allowed'};

        &:hover {
            background-color: rgba(255, 255, 255, 0.19);
        }


        > .MuiSvgIcon-root {
        font-size: 20px;
        margin-right: 8px;
    }
`


const CSOption = styled.div`
        position: relative;
        padding: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.5);
        cursor: not-allowed;

        &:hover {
            background-color: rgba(255, 255, 255, 0.19);
        }


        > .MuiSvgIcon-root {
        font-size: 20px;
        margin-right: 8px;
    }
`

const CSBox = styled.div`
    position: absolute;
    background-color: black;
    color: lightyellow;
    border-radius: 5px;
    display: none;
    left: 100px;
    top: -10px;
    padding: 2px 5px;
    font-size: 14px;

    ${CSOption}:hover & {
        display: block;
    }
`

// mq


const MContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
`

const ToolsDrag = styled.div`
    @media only screen and (max-width: 768px) {
        width: 160px;
        height: fit-content;
        padding: 20px 10px;
        border-radius: 5px;
        background-color: transparent;
        color: white;

        > span {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }
`